import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="world-footer">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-black text-white">🏛️ BẢO TÀNG MỸ THUẬT VIỆT NAM</span>
        <span className="text-[#e0d0c5]/70 hidden sm:inline">· 66 Nguyễn Thái Học, Ba Đình, Hà Nội</span>
      </div>
      <span className="footer-rule" />
      <span className="text-[#ffd166] font-bold">VNFAM Play Edition · Chơi Là Mê ✨</span>
    </footer>
  );
};
